// extracted by mini-css-extract-plugin
export default {"Content":"PageEditionConstante_Content__15ilj","EditionConstante":"PageEditionConstante_EditionConstante__Hpu31","ZoneSecondaire":"PageEditionConstante_ZoneSecondaire__PYnGH"};